<template>
  <el-dialog
    :title="$t('advertManage.delete.title')"
    :visible.sync="visible"
    width="30%"
    @close="handleClose">
    <p>{{ $t('advertManage.delete.confirm') }}</p>
    <p v-if="advertName" class="delete-target">
      {{ advertName }}<span v-if="communityName">（{{ communityName }}）</span>
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAdvert } from '@/api/admin/advertManageApi'

export default {
  name: 'DeleteAdvert',
  data() {
    return {
      visible: false,
      advertId: '',
      advertName: '',
      communityName: ''
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.advertId = row.advertId
      this.advertName = row.adName || ''
      this.communityName = row.communityName || ''
    },
    handleClose() {
      this.advertId = ''
      this.advertName = ''
      this.communityName = ''
    },
    async handleConfirm() {
      try {
        await deleteAdvert(this.advertId)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$emit('success')
        this.visible = false
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '删除轮播图失败')
      }
    }
  }
}
</script>

<style scoped>
.delete-target {
  font-weight: 600;
  color: #303133;
}
</style>
